import React, { useState, useEffect, useContext } from "react";
import styles from "./CreateInterview.module.scss";
import {
  Box,
  IconButton,
  Paper,
  TextField,
  Typography,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Autocomplete,
  Stepper,
  Step,
  StepLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Card,
  CardActionArea,
  Switch,
  FormGroup,
  FormControlLabel,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Snackbar,
  Alert,
  SnackbarCloseReason,
  CircularProgress,
  RadioGroup,
  Radio,
  TableHead,
} from "@mui/material";
import { IQuestion } from "../../models/IQuestion";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  callAPI,
  generateInterviewGPT,
} from "../../services/interview.service";
import { useAuthToken } from "../../hooks/useAuthToken";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import DrawerWrapper from "../../components/DrawerWrapper/DrawerWrapper";
import ConfirmationDialog from "../../components/ConfirmationDialog";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { MessageStore } from "../../context/messageContext";
import GeneralCreateInterview from "../GeneralCreateInterview/GeneralCreateInterview";
import CreateQuestions from "../CreateQuestions/CreateQuestions";

interface ITag {
  Id?:number,
  InterviewId?: number,
  Label: string;
}

function CreateInterview() {
  const [newQuestion, setNewQuestion] = useState<string>("");
  const [questions, setQuestions] = useState<IQuestion[]>([]);
  const [interviewName, setInterviewName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [prompt, setPrompt] = useState<string>("");
  const [emails, setEmails] = useState<string[]>([]);
  const [emailInput, setEmailInput] = useState<string>("");
  const [existingInvitations, setExistingInvitations] = useState<any[]>([]);
  const [interviewUuid, setInterviewUuid] = useState<string | null>(null);
  const [existingQuestions, setExistingQuestions] = useState<IQuestion[]>([]);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [selectedCard, setSelectedCard] = React.useState(0);
  const [checkedCcustom, setCheckedCcustom] = useState<boolean>(false);
  const [newQuestionText, setNewQuestionText] = useState("");
  const [newQuestionContext, setNewQuestionContext] = useState("");
  const [isMandatory, setIsMandatory] = useState(false);
  const [requireAuth, setRequireAuth] = useState(false);
  const [welcomeTitle, setWelcomeTitle] = useState("Hi welcome to our interview");
  const [welcomeMessage, setWelcomeMessage] = useState("We're excited to have you on board. Are you ready to begin?");
  const [completedTitle, setCompletedTitle] = useState("Thank You for completing the interview");
  const [completedMessage, setCompletedMessage] = useState("Thank you for your responses, they are highly valuable to us!");
  const [openDialogConfirmation, setOpenDialogConfirmation] =
    React.useState(false);
  const [selectedCardRemove, setSelectedCardRemove] = React.useState(0);
  const [newInterview, setNewInterview] = useState<any>();
  const [tags, setTags] = useState<ITag[]>([]);
  const [tagInput, setTagInput] = useState<string>("");
  const [open, setOpen] = useState<boolean>(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const accessToken = useAuthToken();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const interviewId = searchParams.get("interviewId");
  const endpoint = "https://fa-np-tl-interviewai-staging.azurewebsites.net/api";

  const steps = ["General Description", "Set Questions", "Send Invitations"];
  const { t } = useTranslation();
  const [statusInterview, setStatusInterview] = React.useState<string>("");

  const [refinedPrompt, setRefinedPrompt] = useState<string>("");
  const [isRefining, setIsRefining] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [chatMode, setChatMode] = useState(false);

  
  const [questiontext, setQuestionText]=useState("")
  const [questionContext, setQuestionContext]=useState("")
  const [newIsMandatory, setNewIsMandatory]=useState(false)
  const [existingQuestionsId, setExistingQuestionsId]=useState<number[]>([])
  
  

  const { setOpenMessage, setShowMessage } = useContext(MessageStore);

  const openMenu = Boolean(anchorEl);



  //step3: change interview status
  const handleChangeStatus = (event: SelectChangeEvent) => {
    setStatusInterview(event.target.value);
  };

  //general:  message
  const handleCloseAlert = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  //general:  fetch interviews
  useEffect(() => {
    const fetchInterviews = async () => {
      if (interviewId) {
        try {
          const options = {
            accessToken,
            method: "GET",
            endpoint: `${endpoint}/interviews?All=yes`,
          };
          const response = await callAPI(options);

          const interview = response.find(
            (item: any) => item.Id.toString() === interviewId
          );

          if (interview) {

            setRequireAuth(interview.AuthOnly);
            setCompletedMessage(interview.CompletedMessage);
            setCompletedTitle(interview.CompletedTitle);
            setWelcomeTitle(interview.WelcomeTitle);
            setWelcomeMessage(interview.WelcomeMessage);
            setInterviewName(interview.Title);
            setDescription(interview.Description);
            setPrompt(interview.Prompt);
            setQuestions(interview.Questions || []);
            setEmails(interview.Invitations.map((invite: any) => invite.Email));
            setInterviewUuid(interview.Uuid);
            setExistingInvitations(interview.Invitations || []);
            setStatusInterview(interview.Status);
            setExistingQuestions(interview.Questions || []);
            setTags(interview.Tags);
            setChatMode(interview.ChatMode || false);
          }
        } catch (error) {
          console.error("Error fetching interviews:", error);
        }
      }
    };

    fetchInterviews();
  }, [interviewId, accessToken, endpoint]);

 
 

  //step2 save all questions
  const saveAllQuestions = async () => {
    try {
      const existingQuestionIds = existingQuestions.map((q) => q.Id);
      const existingQuestiontext = existingQuestions.map((q) => q.QuestionText);
      setExistingQuestionsId(existingQuestionIds)

      for (const question of questions) {
      
        const isExistingQuestion = existingQuestionIds.includes(question.Id);
        const isExistingtextQuestion = existingQuestiontext.includes(question.QuestionText);

       
        const questionData: any = {
          InterviewId: parseInt(interviewId || newInterview.Id || '0'),
          QuestionText: question.QuestionText,
          QuestionOrder: question.QuestionOrder,
          IsRequired: question.IsRequired,
          Context: question.Context,
        };

        if (isExistingQuestion || isExistingtextQuestion ) {
          questionData.Id = question.Id;
        }

        const options = {
          accessToken,
          endpoint: `${endpoint}/question`,
          method: "PUT",
          body: questionData,
        };

        const response = await callAPI(options);
        setExistingQuestions((prev) => [...prev, response])
      }
    } catch (error) {
      console.error("Error saving questions:", error);
    }
  };

  //step2 save invitations
  const saveInvitations = async () => {
    try {
      const emailList = Array.from(
        new Set(
          emails.map((email) => email.trim()).filter((email) => email !== "")
        )
      );

      if (emailList.length === 0) {
        //No emails provided, skipping invitations step.
        return;
      }

      const existingEmails = existingInvitations.map(
        (invite: any) => invite.Email
      );

      for (const email of emailList) {
        if (!existingEmails.includes(email)) {
          if (interviewId) {
            const invitationData = {
              InvitationStatus: "pending",
              InterviewId: parseInt(interviewId) || newInterview.Id,
              Email: email,
            };
            const options = {
              accessToken,
              endpoint: `${endpoint}/invitation`,
              method: "PUT",
              body: invitationData,
            };

            const response = await callAPI(options);

            const invitationCode = response.InvitationCode;

            if (requireAuth) {
              const link = `${window.location.origin}/${
                interviewUuid || newInterview.Uuid
              }`;
            } else {
              const link = `${window.location.origin}/${
                interviewUuid || newInterview.Uuid
              }?invitationCode=${invitationCode}`;
            }
          } else {
            const invitationData = {
              InvitationStatus: "pending",
              Email: email,
              InterviewId: newInterview.Id,
            };
            const options = {
              accessToken,
              endpoint: `${endpoint}/invitation`,
              method: "PUT",
              body: invitationData,
            };

            await callAPI(options);
          }
        }
      }

      for (const existingInvite of existingInvitations) {
        if (!emailList.includes(existingInvite.Email)) {
          await callAPI({
            accessToken,
            endpoint: `${endpoint}/invitation`,
            method: "DELETE",
            body: { Id: existingInvite.Id },
          });
        }
      }
    } catch (error) {
      console.error("Error saving invitations:", error);
    }
  };

  const savetags =async()=>{

    const labeltags = tags.map(tag=>tag.Label)

    const tagdata = {
    "InterviewId": interviewId ? parseInt(interviewId) : newInterview ? newInterview.Id : null,
    "Labels": labeltags
    }
    
    try {
      const options = {
        accessToken,
        endpoint: `${endpoint}/tags`,
        method: "PUT",
        body: tagdata,
      };
  
      if (accessToken) {
        const response = await callAPI(options);
        if (response) {
          //UPDATE TAGGS
        }
      }
    } catch (error) {
      console.error("Error saving interview:", error);
    }
  }

  // step3 save in database all data interview
  const saveInterviewAnswersFunction = async (interviewData: any) => {
    try {
      const options = {
        accessToken,
        endpoint: `${endpoint}/interview`,
        method: "PUT",
        body: interviewData,
      };
      if (accessToken) {
        const response = await callAPI(options);
        if (response) {
          setNewInterview(response);
        }
        handleNext();
      }
    } catch (error) {
      console.error("Error saving interview:", error);
    }
  };


  //general: handle button next
  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  //general: save data button next
  const saveAnswersByNext = async () => {
    if (activeStep === 0) {
      
      const interviewData: any = {
        Uuid: interviewUuid,
        Title: interviewName,
        Description: description,
        Prompt: prompt,
        Tags: tags, 
        Model: "gpt-4o",
        Status: "active",
      };
      savetags()
      saveInterviewAnswersFunction(interviewData);
     
    }
    if (activeStep === 1) {
      const interviewData: any = {
        Uuid: interviewUuid || newInterview?.Uuid,
        WelcomeMessage: welcomeMessage,
        WelcomeTitle: welcomeTitle,
        CompletedMessage: completedMessage,
        CompletedTitle: completedTitle
      };

      saveInterviewAnswersFunction(interviewData);
      await saveAllQuestions();
    }

    if (activeStep === steps.length - 1) {

      if (
        (interviewId !== null && interviewUuid) ||
        (newInterview.Id !== null && newInterview?.Uuid)
      ) {
        const interviewData: any = {
          Uuid: interviewUuid || newInterview?.Uuid,
          status: statusInterview,
          AuthOnly: requireAuth,
          ChatMode: chatMode,
        };

        saveInvitations();
        saveInterviewAnswersFunction(interviewData);
   
        if (newInterview?.Uuid !== undefined) {
          setOpenMessage(true);
          setShowMessage({
            message: "Your interview was created successfully!",
            label: "success",
          });
        } else {
          setOpenMessage(true);
          setShowMessage({
            message: "Your interview was updated successfully!",
            label: "success",
          });
        }
      } else {
       
        const interviewData: any = {
          Title: interviewName,
          Description: description,
          Prompt: prompt,
          Model: "gpt-4o",
          Status: "active",
          Tags: tags, 
          WelcomeMessage: welcomeMessage,
          WelcomeTitle: welcomeTitle,
          CompletedMessage: completedMessage,
          CompletedTitle: completedTitle,
          status: statusInterview,
          AuthOnly: requireAuth,
        };

        saveInvitations();
        saveInterviewAnswersFunction(interviewData);
      }

      navigate("/my-dashboard");
    }
  };

  //step3: handle copy link
  const handleCopyInvitationLink = (
    invitationCode: string,
    interviewUuid: string
  ) => {
    const invitationLink = `${window.location.origin}/public/${interviewUuid}?invitationCode=${invitationCode}`;
    navigator.clipboard.writeText(invitationLink);
  };

  // general: steps
  const isStepOptional = (step: number) => {
    return step === 1;
  };
  // general: skip steps
  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };
  // general: button back in steps
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  // general: skip steps
  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  // step1: close dialog refine
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  // step1: confirmation dialog refine
  const handleConfirmAction = () => {
    setPrompt(refinedPrompt); // Actualizar el prompt original con el refinado
    setOpenDialog(false);
    setRefinedPrompt("");
  };

  // general: require authentication
  const RequireAuthentication = () => {
    setRequireAuth(!requireAuth);
  };
  // step3: copy invitations with auth
  const handleCopyInvitationLinkAuth = () => {
    const invitationLink = `${window.location.origin}/${interviewUuid}`;
    navigator.clipboard.writeText(invitationLink);
  };

  

  // step1: button refine again
  const handleRefineAgain = async () => {
    setIsRefining(true);
    setRefinedPrompt(""); // Limpiamos el prompt refinado anterior

    const refinementPrompt = `Refina y mejora el siguiente prompt para que sea más claro y conciso, manteniendo la esencia y el objetivo del mismo: "${prompt}"`;

    try {
      await generateInterviewGPT(
        refinementPrompt,
        (response: string) => {
          setRefinedPrompt(response); // Simplemente asignamos la nueva respuesta
        },
        setIsRefining
      );
    } catch (error) {
      console.error("Error refinando el prompt:", error);
      setIsRefining(false);
    }
  };

  // step2: remove questions
  const handleRemoveQuestion = async () => {
    setQuestions(
      questions.filter((question) => question.Id !== selectedCardRemove)
    );

    const questionData = {
      Id: selectedCardRemove,
    };
    // if(existingQuestionsId.includes(selectedCardRemove)){
      try {
        const options = {
          accessToken,
          endpoint: `${endpoint}/question`,
          method: "DELETE",
          body: questionData,
        };
  
        if (accessToken) {
          const response = await callAPI(options);
  
          setOpenMessage(true);
          setShowMessage({
            message: "Your question was removed successfully!",
            label: "success",
          });
        }
      } catch (error) {
        console.error("Error saving interview:", error);
      }
    // }
    
    setOpenDialogConfirmation(false);
  };

  // general: delete confirmation
  const handleCloseDialogConfirmation = () => {
    setOpenDialogConfirmation(false);
  };

  

  const handleChangeChatMode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChatMode(
      (event.target as HTMLInputElement).value === "chat" ? true : false
    );
  };

  return (
    <>
      <DrawerWrapper open={open} setOpen={setOpen} />
      <div style={{ width: open ? "80%" : "95%" }} className={styles.container}>
        <Stepper
          activeStep={activeStep}
          style={{ width: "80%" }}
          sx={{
            "& .MuiStepIcon-root": {
              color: "#ccc", // default color for inactive steps
            },
            "& .MuiStepIcon-root.Mui-completed": {
              color: "#28496b", // completed steps
            },
            "& .MuiStepIcon-root.Mui-active": {
              color: "#fff", // number color
              backgroundColor: "#28496b", // background circle color
              borderRadius: "50%",
              padding: "1px",
            },
            "& .MuiStepConnector-line": {
              borderColor: "#28496b", // connector line
            },
          }}
        >
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            if (isStepOptional(index)) {
              /* labelProps.optional = (
                <Typography variant="caption">Optional</Typography>
              ); */
            }
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>

        {activeStep === 0 && (
          <GeneralCreateInterview
            interviewName={interviewName}
            setInterviewName={setInterviewName}
            description={description}
            setDescription={setDescription}
            tags={tags}
            setTags={setTags}
            tagInput={tagInput}
            setTagInput={setTagInput}
            setPrompt={setPrompt}
            setOpenDialog={setOpenDialog}
            setIsRefining={setIsRefining}
            setRefinedPrompt={setRefinedPrompt}
            prompt={prompt}
          />
        )}
        {activeStep === 1 && (
          <CreateQuestions
            questions={questions}
            setSelectedCard={setSelectedCard}
            selectedCard={selectedCard}
            setQuestions={setQuestions}
            setAnchorEl={setAnchorEl}
            setSelectedCardRemove={setSelectedCardRemove}
            anchorEl={anchorEl}
            openMenu={openMenu}
            setOpenDialogConfirmation={setOpenDialogConfirmation}
            setWelcomeTitle={setWelcomeTitle}
            welcomeTitle = {welcomeTitle}
            welcomeMessage={welcomeMessage}
            setWelcomeMessage={setWelcomeMessage}
            setShowMessage={setShowMessage}
            setOpenMessage={setOpenMessage}
            newQuestionText={newQuestionText}
            interviewId={interviewId}
            isMandatory={isMandatory}
            newQuestionContext={newQuestionContext}
            setIsMandatory={setIsMandatory}
            setNewQuestionContext={setNewQuestionContext}
            setNewQuestionText={setNewQuestionText}
            setCheckedCcustom={setCheckedCcustom}
            checkedCcustom={checkedCcustom}
            setCompletedTitle={setCompletedTitle}
            setCompletedMessage={setCompletedMessage}
            setQuestionText={setQuestionText}
            questiontext={questiontext}
            questionContext={questionContext}
            setQuestionContext={setQuestionContext}
            setNewIsMandatory={setNewIsMandatory}
            newIsMandatory={newIsMandatory}
            newInterview={newInterview}
            completedTitle={completedTitle}
            completedMessage ={completedMessage}
          />
        )}
        {activeStep === 2 && (
          <div style={{ marginTop: "1.2rem", width: "100%", padding: "30px" }}>
            {/*   <h4 style={{ marginTop: "50px", marginBottom: "-20px" }}>General Description</h4> */}
            <Typography variant="h6" className={styles.title}>
              {"Invitations"}
            </Typography>
            <FormControl>
              <Typography variant="body2" component="div">
                {"Type of interview"}
              </Typography>

              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={chatMode === false ? "question" : "chat"}
                onChange={handleChangeChatMode}
              >
                <FormControlLabel
                  value="chat"
                  control={
                    <Radio
                      sx={{
                        color: "#28496b",
                        "&.Mui-checked": {
                          color: "#28496b",
                        },
                      }}
                    />
                  }
                  label="Chat"
                />
                <FormControlLabel
                  value="question"
                  control={
                    <Radio
                      sx={{
                        color: "#28496b",
                        "&.Mui-checked": {
                          color: "#28496b",
                        },
                      }}
                    />
                  }
                  label="Question by question"
                />
              </RadioGroup>
            </FormControl>

            <FormGroup
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
              }}
            >
              <div style={{ marginLeft: "6px" }}>
                <Typography variant="body2" component="div">
                  {"Require authentication"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {"Users require authentication to enter to the interview"}
                </Typography>
              </div>
              <Switch
                checked={requireAuth}
                onChange={RequireAuthentication}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#28496b",
                    "& + .MuiSwitch-track": {
                      backgroundColor: "#28496b",
                    },
                  },
                  "& .MuiSwitch-track": {
                    backgroundColor: "#ccc", // default track color when unchecked
                  },
                }}
              />
            </FormGroup>

            <FormControl
              variant="standard"
              sx={{ m: 1, width: "100%", marginTop: "40px" }}
            >
              <Typography variant="body2" component="div">
                {"Status"}
              </Typography>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={statusInterview}
                onChange={handleChangeStatus}
                label="Status"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={"active"}>active</MenuItem>
                <MenuItem value={"inactive"}>inactive</MenuItem>
              </Select>
            </FormControl>
            {/*   <h4 style={{ marginTop: "50px", marginBottom: "-20px" }}>General Description</h4> */}
            <Typography
              variant="h6"
              className={styles.title}
              // sx={{ marginTop: "50px" }}
            >
              {"Send Invitations:"}
            </Typography>
            <div
              style={{
                // marginTop: "20px",
                marginLeft: "6px",
              }}
              className={styles.stepContainer}
            >
              <div className={styles.column}>
                <Typography
                  variant="body2"
                  component="div"
                  // sx={{ marginBottom: "10px" }}
                >
                  {t("general.admin.invitationEmail")}
                </Typography>
                <Box className={styles.questionContainer}>
                  <Autocomplete
                    multiple
                    //disableClearable={viewOnly}

                    options={[]}
                    fullWidth
                    freeSolo
                    limitTags={3}
                    getOptionLabel={(option) => option}
                    value={emails}
                    onChange={(event: any, newValue: string[], reason) => {
                      setEmails(newValue);
                    }}
                    inputValue={emailInput}
                    onInputChange={(event, newInputValue) => {
                      setEmailInput(newInputValue);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setEmails([...emails, emailInput]);
                        setEmailInput("");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={t("general.admin.email")} //!viewOnly ? t("general.admin.email") : ""}
                      />
                    )}
                  />
                </Box>
              </div>
            </div>
            <br />
            {requireAuth ? (
              interviewId ? (
                <Box className={styles.questionContainer}>
                  <p>
                    {window.location.origin}/{interviewUuid}
                  </p>
                  <Tooltip title="Copy invitation link">
                    <IconButton
                      onClick={() => handleCopyInvitationLinkAuth()}
                      size="small"
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              ) : null
            ) : interviewId ? (
              <TableContainer component={Paper} sx={{ marginLeft: "6px" }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Email</TableCell>
                      <TableCell align="right">
                        {" "}
                        {t("general.admin.status")}
                      </TableCell>
                      <TableCell align="right">Link</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {existingInvitations.map((invitation, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {invitation.Email}
                        </TableCell>
                        <TableCell align="right">
                          {invitation.InvitationStatus}
                        </TableCell>
                        <TableCell align="right">
                          <Tooltip title="Copy invitation link">
                            <IconButton
                              onClick={() =>
                                handleCopyInvitationLink(
                                  invitation.InvitationCode,
                                  interviewUuid || ""
                                )
                              }
                              size="small"
                            >
                              <ContentCopyIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
            <br />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "center",
                marginBottom: "30px",
              }}
            ></div>
          </div>
        )}
        {activeStep === steps.length ? (
          <React.Fragment></React.Fragment>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "row", pt: 1 }}>
            <Button
              color="inherit"
              disabled={activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
              variant="contained"
              style={{ display: "flex", padding: "10px 50px" }}
            >
              Back
            </Button>
            <Box sx={{ flex: "1 1 auto" }} />
            {isStepOptional(activeStep) && (
              <Button
                color="inherit"
                onClick={handleSkip}
                sx={{ mr: 1 }}
                style={{
                  backgroundColor: "transparent",
                  color: "#27496b",
                  display: "flex",
                  padding: "10px",
                }}
              >
                Skip
              </Button>
            )}
            <Button
              onClick={saveAnswersByNext}
              variant="contained"
              style={{ display: "flex", padding: "10px 50px" }}
            >
              {activeStep === steps.length - 1 ? "Save & Finish" : "Next"}
            </Button>
          </Box>
        )}
      </div>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Your interview was saved successfully!
        </Alert>
      </Snackbar>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseOutlinedIcon />
        </IconButton>
        <DialogTitle id="alert-dialog-title" textAlign="center">
          {"Refine prompt with AI"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {isRefining ? (
              <CircularProgress size={24} />
            ) : (
              refinedPrompt || "No refined prompt generated yet"
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleRefineAgain}
            color="secondary"
            variant="outlined"
            disabled={isRefining}
          >
            {"Refine again"}
          </Button>
          <Button
            onClick={handleConfirmAction}
            color="primary"
            variant="contained"
            autoFocus
            disabled={isRefining || !refinedPrompt}
          >
            {"Use prompt"}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={openDialogConfirmation}
        onClose={handleCloseDialogConfirmation}
        onConfirm={handleRemoveQuestion}
        message={"Are you sure of deleting this question?"}
      />
    </>
  );
}

export default CreateInterview;
